import React, { useContext, useEffect } from "react"
import { Outlet , useLocation } from "react-router-dom"

import BreadCrumbs from "../components/BreadCrumbs"
import Footer from "../components/Common/Footer"
import Header from "../components/Common/Header"
import PageTitle from "../components/PageTitle"
import { SideBar } from "../components/Sidebar"
import { GlobalContext } from "../context/GlobalContext"
import RoutesConfig from "../routes/RoutesConfig"

const MainLayout = () => {
    const location = useLocation()
    const { hamburger } = useContext(GlobalContext)
    const hideSideBarRoutes = [
        "productcatalogue",
        "/service-network",
        "/myApprovals",
        "/service-network/add-service-center-address",
        "/service-network/edit-service-center-address",
        "/newsandbulletin"
    ]

    const { setIsUserManagement, setIsProductsManagement } = useContext(GlobalContext)
    useEffect(() => {
        if (
            location.pathname === "/manageuser" ||
			location.pathname === "/rolespermission"
        ) {
            setIsUserManagement(true)
        }else if(location.pathname === "/product-management" || location.pathname?.includes("/product-management")){
            setIsUserManagement(false)
            setIsProductsManagement(true)
        } else {
            setIsProductsManagement(false)
            setIsUserManagement(false)
        }
    }, [location.pathname])

    return (
        <div className="pt-[103px]">
            <Header />
            <div className="flex flex-col px-8">
                <BreadCrumbs routes={ RoutesConfig } />
                <PageTitle routes={ RoutesConfig } />
            </div>
            <div className={`flex p-8 bg-primary-200 w-full pt-4 pb-6 ${hamburger ? "" : "gap-6 "}`}>
                { !hideSideBarRoutes.includes(location.pathname) && (
                    <div className={`${hamburger ? "" : "w-1/6"}`}>
                        <SideBar />
                    </div>
                ) }
                <main
                    className={
                        !hideSideBarRoutes
                            ? "overflow-x-auto w-11/12"
                            : `${location.pathname === "/service-network" ? "w-full" : "overflow-x-auto w-full"}`
                    }
                >
                    <Outlet />
                </main>
            </div>
            <Footer />
        </div>
    )
}

export default MainLayout
